<template>
  <div>
    <b-table striped hover :items="items" :fields="fields"></b-table>
  </div>
</template>

<script>
	import { getSubUserList } from 'src/db'
	import { mapState } from 'vuex'

	export default {
		name: "SubUserList",
		computed: {
			...mapState('firebase', ['user', 'prospects', 'campaigns'])
		},
		methods: {
            itemsProvider(ctx, callback) {
                getSubUserList({UID: this.user.id})
				.then((res) => {
                  const items =  this.initTable(res)
                  callback(items)
                })
                .catch(err => alert(`Failure getting sub user list: ${err}`));
                return null
            },
            initTable(res) {
				let itemArray = [];
                for (let su of res.data) {
                    itemArray.push(su);
				}
                return itemArray;
            }
		},
		data() {
			return {
				fields: ['First','Last','Email','Number',{key:'Twilio',label: 'taTEXT Number',}],
                items:this.itemsProvider
			}
		}
	}
</script>